<template>
	<div class="search-list-item">
		<a :href="item.Url" class="search-list-item-title" v-html="$options.filters.highlight(item.Title, specification.Query)"></a>

		<div v-if="item.Breadcrumbs !== null && item.Breadcrumbs.length" class="search-list-item-breadcrumb">
			<ul>
				<li v-for="crumb in item.Breadcrumbs">
					<a :href='crumb.Url'>{{ crumb.Title }}</a>
				</li>
			</ul>
		</div>

		<div class="search-list-item-body" v-html="$options.filters.highlight(item.Summary, specification.Query)" v-if="item.Summary.length"></div>
	</div>
</template>

<script>
	export default {
		props: ['item', 'specification'],
		mounted: function () {
		},
		filters: {
			highlight: function(words, query) {
				let text = new RegExp("(" + query + ")","gi"); 

				return words.replace(text, "<span class='highlight'>$1</span>");
			}
		}
    }
</script>